import React from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import Cash1Component from './components/Cash1Component'

const Cash1 = () => {
    return (
        <>
            <section className='cash1-section'>
                <CommonBox heading=" 충전하기 " englishHeading=" charge" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
                    <Cash1Component />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>

        </>
    )
}

export default Cash1